import React from 'react'
import { Route } from 'react-router-dom'
import { AccessControl } from 'components/Shared/AccessControl'
import { MainPage } from "./components/Main/Main";

function PrivateRoute ({ component: Component, allowedPrivileges, ...rest }) {

  return (
    <Route
      {...rest}
      render={props =>
        <AccessControl
          allowedPrivileges={allowedPrivileges}
          renderNoAccess={() => <MainPage messageToken={"noAuthority"}></MainPage>}
        >
          <Component {...props} />
        </AccessControl>
      }
    />
  )
}

export default PrivateRoute
